// extracted by mini-css-extract-plugin
export var button = "_nx-2";
export var card = "_nx-0";
export var closeButtonContainer = "_nx-3";
export var iconContainer = "_nx-1";